import React from 'react';
import "./ParticipantGuide.css";

export default function ParticipantGuide () {
  return (
    <div className="participant-guide-container">
        <h1>PARTICIPANT GUIDE</h1>
        <p>
        View participant guide{" "}
        <a
          href="https://drive.google.com/file/d/1SPq7lJuX2rHegqmwGD2mn2pkUP_caIBX/view?usp=drive_link"
          className="participant-guide-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
      </p>
    </div>
  );
}

